/**
 * Single source of truth for public-facing Sweat With Slay events.
 *
 * Both `/legacy` (Sacrifice page) and `/events` render from this file.
 * Do NOT hard-code registration pricing — the run organizer sets it and it
 * changes year to year. Only link out to the official registration URL.
 *
 * Shape:
 *   id (unique slug), name, teamName, date (ISO yyyy-mm-dd),
 *   dateLabel (pretty format for humans), time, location, address,
 *   registrationUrl, status ("upcoming" | "past")
 */

export const EVENTS = [
  {
    id: "t2t-climb-tampa-2026",
    name: "Tunnel to Towers Climb — Tampa",
    teamName: "Team Sweat With Slay",
    date: "2026-10-03",
    dateLabel: "Saturday, October 3, 2026",
    time: "8:00 AM",
    location: "One Tampa City Center",
    address: "201 N. Franklin Street, Tampa, FL 33602",
    registrationUrl: "https://runsignup.com/Race/FL/Tampa/TunneltoTowersClimbTampaFL",
    status: "upcoming",
  },
];

export const UPCOMING_EVENTS = EVENTS.filter((e) => e.status === "upcoming");
